import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';

import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { UiPreferencesService } from '../core/services/ui-preferences.service';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatSlideToggleModule
  ],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss'
})
export class SettingsComponent implements OnInit {
  private readonly uiPrefs = inject(UiPreferencesService);
  private readonly fb = inject(FormBuilder);
  private readonly snackBar = inject(MatSnackBar);

  settingsForm: FormGroup;
  loading = false;

  constructor() {
    this.settingsForm = this.fb.group({
      companyName: ['Trusted Technologies', Validators.required],
      companyEmail: ['info@trustedtech.com', [Validators.required, Validators.email]],
      companyPhone: ['+1234567890'],
      companyAddress: ['123 Business Ave, Tech City'],
      currency: ['USD'],
      timezone: ['UTC-5'],
      language: ['English'],
      emailNotifications: [true],
      smsNotifications: [false],
      autoBackup: [true],
      darkMode: [this.uiPrefs.isDark()]
    });
  }

  ngOnInit(): void {
    this.settingsForm.get('darkMode')?.valueChanges.subscribe((enabled: boolean) => {
      this.uiPrefs.setTheme(enabled ? 'dark' : 'light');
    });
  }

  saveSettings(): void {
    if (this.settingsForm.invalid) {
      this.snackBar.open('Please fix validation errors.', 'Close', { duration: 3000 });
      return;
    }

    this.loading = true;
    this.uiPrefs.setTheme(this.settingsForm.value.darkMode ? 'dark' : 'light');

    setTimeout(() => {
      this.loading = false;
      this.snackBar.open('Settings saved successfully!', 'Close', { duration: 3000 });
    }, 800);
  }

  resetSettings(): void {
    if (confirm('Reset all settings to default values?')) {
      this.settingsForm.reset({
        companyName: 'Trusted Technologies',
        companyEmail: 'info@trustedtech.com',
        companyPhone: '+1234567890',
        companyAddress: '123 Business Ave, Tech City',
        currency: 'USD',
        timezone: 'UTC-5',
        language: 'English',
        emailNotifications: true,
        smsNotifications: false,
        autoBackup: true,
        darkMode: false
      });
      this.uiPrefs.setTheme('light');
      this.snackBar.open('Settings reset to default.', 'Close', { duration: 3000 });
    }
  }
}
